export default (apolloAgent, job_id, type) => {
    const device = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
        ? 'mobile' : 'desktop';
    apolloAgent.mutate({
        mutation: require('../graphql/Log.gql'),
        variables: {
            job_id: job_id,
            type: `${device}_${type}`
        }
    });
}